import Glide from '@glidejs/glide'
import {DOM} from "./_variables";

export default {
    galleries: () => {

      const sliders = document.querySelectorAll('.glide');

      if (sliders.length) {
        for (const slider of sliders) {

          const glide = new Glide(slider, {
            type: 'carousel',
            perView: 2,
            focusAt: 0,
            startAt: 0,
            gap: 40,
            peek: {
              before: 0,
              after: 400
            },
            breakpoints: {
              600: {
                perView: 1,
                gap: 10,
                peek: {
                  before: 0,
                  after: 0
                }
              }
            }
          })

          glide.mount()
        }
      }

      const slidersAbout = document.querySelectorAll('.glide_about');

      if (slidersAbout.length) {
        for (const sliderAbout of slidersAbout ) {

          const glide = new Glide(sliderAbout, {
            type: 'carousel',
            perView: 3,
            focusAt: 'center',
            startAt: 0,
            gap: 10,
            rewind: false,
            breakpoints: {
              600: {
                perView: 1,
                gap: 10,
              }
            }
          })

          glide.mount()
        }
      }
    }
}
